<div class="grid-table-form" [ngStyle]="{width: width}">
    <app-editable-table
        [tableMeta]="tableConfig"
        [tableData]="tableData"
        [disableTable]="disable"
        [allowSelection]="false"
        (dataUpdated)="handleTableDataChange($event)"
        (rowActionTriggered)="handleInlineAction($event);"
        ></app-editable-table>
    <button class="btn ghost_button" *ngIf="!disable" (click)="addNewRow()">
      <app-svg-icon path="assets/icons/plus_icon.svg" style="width: 24px;height: 24px; display: flex"></app-svg-icon>
      Add New
    </button>
</div>